/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { useAlert } from '../../../Common/hooks';
import { getResolutionFilters } from '../../selectors';
import { getResolutionReports } from '../../services';
import { resolutionError } from '../../constants';

const useResolutionReport = () => {
  const filters = useSelector(getResolutionFilters);
  const { showAlert } = useAlert();
  const [resolutionReports, setResolutionReports] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const handleFilterChange = async () => {
    if (filters.aggregatorID && filters.payerID) {
      setIsLoading(true);
      const { resolutionCodes, status } = await getResolutionReports(filters);
      if (status === 404) {
        showAlert({ color: 'error', icon: 'exclamation', message: resolutionError });
      }

      setResolutionReports(resolutionCodes);
      setIsLoading(false);
    } else {
      setResolutionReports([]);
    }
  };

  useEffect(() => {
    handleFilterChange();
  }, [filters]);

  return {
    resolutionReports,
    isLoading,
  };
};

export default useResolutionReport;
